export default class DtoDistributionAssociatedTown {
    constructor(obj) {
        this.idStation = obj.idStation // Option[Long],
        this.city = obj.city // Option[String],
        this.member = obj.member // Option[Boolean],
        this.servedPopulation = obj.servedPopulation // Option[Int]
    }
}